if (!customElements.get("td-gallery-slider")) {
    class TdGallerySlider extends HTMLElement {
      constructor() {
        super();
        
        this.sliderWrapper = this.querySelector('.keen-slider')
        
      }

      connectedCallback() {
        setTimeout(() => {
            this.initSlider()
        }, 0)
      
      }
      initSlider() {
        if(this.sliderWrapper) {           
             let animation = { duration: 40000, easing: (t) => t }
             let settings_autoplay = this.sliderWrapper.dataset.autoplay.toLowerCase() === 'true'
             let settings_navigation = this.sliderWrapper.dataset.navigation.toLowerCase() === 'true'
             let settings_drag = this.sliderWrapper.dataset.drag.toLowerCase() === 'true'
            
             let navigation = function(slider) {
                if(settings_navigation == false) return
                let wrapper, dots, arrowLeft, arrowRight

                function markup(remove) {
                  wrapperMarkup(remove)
                  dotMarkup(remove)
                  arrowMarkup(remove)
                }
              
                function removeElement(elment) {
                  elment.parentNode.removeChild(elment)
                }
                function createDiv(className) {
                  var div = document.createElement("div")
                  var classNames = className.split(" ")
                  classNames.forEach((name) => div.classList.add(name))
                  return div
                }
              
                function arrowMarkup(remove) {
                  if (remove) {
                    removeElement(arrowLeft)
                    removeElement(arrowRight)
                    return
                  }
                  arrowLeft = createDiv("arrow arrow--left")
                  arrowLeft.addEventListener("click", () => slider.prev())
                  arrowRight = createDiv("arrow arrow--right")
                  arrowRight.addEventListener("click", () => slider.next())
              
                  wrapper.appendChild(arrowLeft)
                  wrapper.appendChild(arrowRight)
                }
              
                function wrapperMarkup(remove) {
                  if (remove) {
                    var parent = wrapper.parentNode
                    while (wrapper.firstChild)
                      parent.insertBefore(wrapper.firstChild, wrapper)
                    removeElement(wrapper)
                    return
                  }
                  wrapper = createDiv("navigation-wrapper")
                  slider.container.parentNode.appendChild(wrapper)
                  wrapper.appendChild(slider.container)
                }
              
                function dotMarkup(remove) {
                  if (remove) {
                    removeElement(dots)
                    return
                  }
                  dots = createDiv("dots")
                  slider.track.details.slides.forEach((_e, idx) => {
                    var dot = createDiv("dot")
                    dot.addEventListener("click", () => slider.moveToIdx(idx))
                    dots.appendChild(dot)
                  })
                  wrapper.appendChild(dots)
                }
              
                function updateClasses() {
                  var slide = slider.track.details.rel
                  slide === 0
                    ? arrowLeft.classList.add("arrow--disabled")
                    : arrowLeft.classList.remove("arrow--disabled")
                  slide === slider.track.details.slides.length - 1
                    ? arrowRight.classList.add("arrow--disabled")
                    : arrowRight.classList.remove("arrow--disabled")
                  Array.from(dots.children).forEach(function (dot, idx) {
                    idx === slide
                      ? dot.classList.add("dot--active")
                      : dot.classList.remove("dot--active")
                  })
                }
              
                slider.on("created", () => {
                  markup()
                  updateClasses()
                })
                slider.on("optionsChanged", () => {
                  markup(true)
                  markup()
                  updateClasses()
                })
                slider.on("slideChanged", () => {
                  updateClasses()
                })
                slider.on("destroyed", () => {
                  markup(true)
                })
            }
            let slider = new KeenSlider(this.sliderWrapper,  {
                loop: true,
                renderMode: "performance",
                drag: settings_drag,
                slides: {
                    perView: 1.5,
                    spacing: 10,
                },
                breakpoints: {
                    '(min-width: 750px)': {
                        slides: {
                            perView: 4,
                            spacing: 10,
                        },
                    },
                },
                created(s) {
                    if(settings_autoplay) s.moveToIdx(5, true, animation)
                },
                updated(s) {
                    if(settings_autoplay) s.moveToIdx(s.track.details.abs + 7, true, animation)
                },
                animationEnded(s) {
                    if(settings_autoplay) s.moveToIdx(s.track.details.abs + 7, true, animation)
                }
            }, [navigation])
          }
      }
  
    }

  
    customElements.define("td-gallery-slider", TdGallerySlider);
  }
  